import Loading from "@/components/Loading";
import AdminLayout from "@/layout/AdminLayout";
import React from "react";
import {PAGE_URL} from "../services/constant";
const NebulaUltraLog = React.lazy(() =>
    import('../NebulaUltraLog')
);
const nebulaUltraLogRoutesRegistry = [
    {
        path: PAGE_URL.NEBULA_ULTRA_LOG_PAGE,
        element: <NebulaUltraLog />,
        loading: <Loading />,
        layout: AdminLayout,
    },
];

export default nebulaUltraLogRoutesRegistry;

